import { createRouter } from "@tanstack/react-router";

import { queryClient } from "@/lib/query-client";
import { routeTree } from "@/routeTree.gen";

/**
 * Yönlendirici.
 *
 * `auth` bağlamı burada bilerek boş bırakılıyor: gerçek değeri React ağacındaki
 * sağlayıcıdan geliyor ve <RouterProvider context={{ auth }}> ile veriliyor.
 * Böylece oturum değiştiğinde rota korumaları (`beforeLoad`) yeniden çalışıyor.
 */
export const router = createRouter({
  routeTree,
  context: {
    auth: undefined!,
    queryClient,
  },
  defaultPreload: "intent",
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
